import { render, staticRenderFns } from "./addnewopt.vue?vue&type=template&id=6047ec28&scoped=true&"
import script from "./addnewopt.vue?vue&type=script&lang=js&"
export * from "./addnewopt.vue?vue&type=script&lang=js&"
import style0 from "./addnewopt.vue?vue&type=style&index=0&id=6047ec28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047ec28",
  null
  
)

export default component.exports